export const getKeyName = (key, obj, keyFormat) => {
  let keyName = key
  if (keyFormat) {
    const formattedKey = keyFormat.replace('{}', key)
    if (obj.hasOwnProperty(formattedKey)) {
      keyName = formattedKey
    }
  }

  return keyName
}
